import analytics from "web/script/analytics/analytics";
import { ProductBuyOptionsSerializer } from "web/types/serializers";

export function baseAffiliateAnalyticsConfig(
    mainBuyOption: ProductBuyOptionsSerializer,
    productId: string
): {
    href: string;
    eventCategory: string;
    eventAction: string;
    eventCustomData: {
        buy_option_id: string;
        product_id: string;
        retailer_slug: string;
    };
} {
    return {
        href: mainBuyOption.affiliate_url || "",
        eventCategory: "oos-product-hero",
        eventAction: "click",
        eventCustomData: {
            buy_option_id: mainBuyOption.link_id.toString(),
            product_id: productId,
            retailer_slug: mainBuyOption.retailer_slug,
        },
    } as const;
}

export function sendAnalyticsEvent(
    category: string,
    action: string,
    label: string,
    isInteraction = false,
    customData?: Record<string, any>
): void {
    analytics.event(
        category,
        action,
        label,
        !isInteraction, // nonInteraction
        customData, // customData
        "", // subType
        {}, // checkoutData
        [],
        false,
        false // itemData
    );
}
